<template>
  <div>
    <global-table
      :table-data="customerAssetReturn"
      :loading="loading"
      :per-page="10"
      :table-detail="tableDetail"
      :bordered="true"
      :hover="true"
      :striped="false"
      :id-modals="'customerAssetReturnForm'"
      :redirect-detail="false"
      :edit-button="false"
      :show-add-button="childAddButton"
      :remove-button="childAddButton"
      :fields="fieldsCustomerAssetReturn"
      addButton="Pengembalian Asset"
      @editForm="editForm"
      @resetForm="resetForm"
      @removeForm="removeForm"
    ></global-table>

    <b-modal
      ref="customerAssetReturnForm"
      id="customerAssetReturnForm"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Pengembalian asset dari konsumen</h3>
      </div>

      <div v-if="!loadingSubmit">
        <b-form id="customerAssetReturnForm" validated novalidate @submit="saveReturnAsset">
          <b-row>
            <b-col sm="3">
              <b-form-group label-for="assign_return_to" label="Perintahkan kepada">
                <model-select
                  id="assign_return_to"
                  :options="listEmployee"
                  v-model="$v.customerAssetReturnForm.assign_return_to.$model"
                  :isError="$v.customerAssetReturnForm.assign_return_to.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="customerAssetReturnForm.assign_return_to === null"
                  class="invalid-feedback-custom"
                >Driver yang mengirim harus di isi.</div>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group label-for="customer_asset_id" label="Asset yang akan di tarik">
                <model-select
                  id="customer_asset_id"
                  :options="customerAssetAvail"
                  v-model="$v.customerAssetReturnForm.customer_asset_id.$model"
                  :isError="$v.customerAssetReturnForm.customer_asset_id.$invalid"
                  required
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div v-if="customerAssetReturnForm.customer_asset_id === null" class="invalid-feedback-custom">Asset harus di pilih.</div>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label-for="return_date" label="Tanggal Pengambilan Asset">
                <v-date-picker
                  id="return_date"
                  :input-props="{ class: 'form-control', placeholder: 'Tanggal Pengambilan Asset', required: ''}"
                  :state="!$v.customerAssetReturnForm.return_date.$invalid"
                  v-model="$v.customerAssetReturnForm.return_date.$model"
                ></v-date-picker>
                <div
                  v-if="$v.customerAssetReturnForm.return_date.$invalid"
                  class="invalid-feedback-custom"
                >Tanggal Pengambilan Asset harus di isi.</div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6">
              <b-form-group label-for="description_return" label="Deskripsi">
                <b-form-textarea
                  id="description_return"
                  :rows="3"
                  :max-rows="6"
                  v-model="$v.customerAssetReturnForm.description_return.$model"
                  :state="!$v.customerAssetReturnForm.description_return.$invalid"
                ></b-form-textarea>
                <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
             <b-col sm="3">
                <b-form-group label-for="status" label="Status Barang">
                  <model-select
                    id="status"
                    :options="listAssetStatus"
                    v-model="$v.customerAssetReturnForm.asset_status.$model"
                    :isError="$v.customerAssetReturnForm.asset_status.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="customerAssetReturnForm.asset_status === null"
                    class="invalid-feedback-custom"
                  >Status Barang harus di isi.</div>
                </b-form-group>
              </b-col>
          </b-row>

          <div class="float-right">
            <b-button type="button" size="sm" variant="danger" @click="cancelReturnAsset">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
            <b-button
              type="button"
              size="sm"
              variant="primary"
              @click="saveReturnAsset"
              :disabled="$v.customerAssetReturnForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-form>
      </div>

      <div v-else>
        <loading></loading>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "asset-return",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    },
    customer: {
      type: [Array, Object],
      default: () => {}
    },
    customerAssetReturn: {
      type: [Array],
      default: () => []
    },
    customerAssetAvail: {
      type: [Array],
      default: () => []
    },
    listEmployee: {
      type: [Array],
      default: () => []
    },
    listAssetStatus: {
      type: [Array],
      default: () => []
    },
    loading: {
      type: Boolean,
      default: true
    },
    childAddButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fieldsCustomerAssetReturn: [
        {
          key: "contract_number_return_download",
          label: "Nomor Kontrak",
          sortable: true
        },
        { key: "serial_number", label: "Serial Number" },
        { key: "owner", label: "Pemilik" },
        { key: "asset_name", label: "Nama Barang" },
        { key: "return_date", label: "Tanggal Pengembalian" },
        { key: "status_name", label: "Status" },
        { key: "description_return", label: "Deskripsi" },
        { key: "action", label: "Action", class: "text-center width-100" }
      ],
      customerAssetReturnForm: interfaces.customer_asset,
      loadingSubmit: false
    };
  },
  validations: {
    customerAssetReturnForm: {
      assign_return_to: { required },
      customer_asset_id: { required },
      return_date: { required },
      description_return: { required },
      asset_status: {required}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {},
    reload(cust_id) {
      this.$emit("reload", cust_id);
    },
    editForm: function() {},
    resetForm: function() {
      for (var a in interfaces.customer_asset) {
        if (a === "status") {
          interfaces.customer_asset[a] = "2";
        } else {
          interfaces.customer_asset[a] = null;
        }
      }
      this.customerAssetReturnForm = interfaces.customer_asset;
    },
    removeForm: function(data) {
      if (confirm("Apakah anda ingin membatalkan penarikan asset ini ?")) {
        this.loadingSubmit = true;
        let customer_asset = data;
        customer_asset.status = "4";
        this.axios
          .put("web/customer/change-customer-asset/", customer_asset)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Batalkan penarikan asset konsumen",
                message: response.data.message
              });
            }
          })
          .catch(error => {
            this.expired(error, "Batalkan penarikan asset konsumen");
          })
          .finally(() => {
            this.loadingSubmit = false;
            //this.reload(this.customer.id);
            this.reload(this.customer.request_id);
          });
      }
    },
    saveReturnAsset: function(evt) {
      if (confirm("Apakah anda ingin melakukan penarikan asset ini ?")) {
        this.loadingSubmit = true;
        let customer_asset = this.customerAssetReturnForm;
        customer_asset.request_code = this.customer.request_code;
        this.axios
          .put("web/customer/change-customer-asset/", customer_asset)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah asset konsumen",
                message: response.data.message
              });
            }
            this.cancelReturnAsset();
          })
          .catch(error => {
            this.expired(error, "Tambah asset konsumen");
          })
          .finally(() => {
            this.loadingSubmit = false;
            //this.reload(this.customer.id);
            this.reload(this.customer.request_id);
          });
      }
    },
    cancelReturnAsset: function() {
      this.$refs.customerAssetReturnForm.hide();
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
